import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
import { toRef } from 'vue';
import { Menu as AMenu } from 'ant-design-vue';
import XDropdownMenuItem from './xDropdownMenuItem.vue';
const __default__ = {
  name: 'XDropdownMenu'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const items = toRef(props.items);
    const handleMenuClick = item => {
      emit('item-click', item);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(AMenu), null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, idx) => {
          return _openBlock(), _createBlock(XDropdownMenuItem, {
            key: idx,
            title: item.title,
            icon: item.icon,
            action: item.action,
            loading: item.loading,
            disabled: item.disabled,
            children: item.children,
            onClick: handleMenuClick
          }, null, 8, ["title", "icon", "action", "loading", "disabled", "children"]);
        }), 128))]),
        _: 1
      });
    };
  }
});